export const strToTitleCase = (str) => {
  let words = str.split(" ");
  let capitalized = words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.substring(1, word.length);
  });
  return capitalized.join(" ");
};
